<div
  class="container container-cart site_b2c"
  (window:resize)="onResize($event)"
  style="margin-bottom: 40px"
  *ngIf="cartSession"
>
  <app-guided-steps [step]="3"></app-guided-steps>

  <div class="row">
    <!-- Start::despacho a domicilio o retiro en tienda (desktop) -->
    <ng-container *ngIf="innerWidth >= 450">
      <div
        class="col-xl-4 col-lg-4 col-md-6"
        style="padding: 15px; background-color: #e3e3e3; margin-right: 10px"
      >
        <div class="card h-100">
          <div class="card-body">
            <div
              class="card-header"
              style="display: inline-block"
              style="color: #0063b9"
            >
              Información de retiro
            </div>

            <!-- Start::despacho a domicilio (desktop) -->
            <div
              *ngIf="cartSession.shipment?.deliveryMode != 'pickup'"
              class="row block_despacho"
            >
              <div
                class="col-12 py-0"
                style="flex-direction: column; justify-content: center"
              >
                <div
                  style="
                    color: #0063b9;
                    font-size: small;
                    font-weight: bold;
                    padding-left: 10px;
                    border-left: 1px solid #005db9;
                    border-right: 1px solid #005db9;
                    border-radius: 0px;
                    border-top: 1px solid #005db9;
                  "
                >
                  <div
                    class="row"
                    style="padding-top: 10px; margin-bottom: -5px"
                  >
                    <div class="ms-1 col-12 py-0 flex justify-content-start">
                      DESPACHO A DOMICILIO
                    </div>
                  </div>
                </div>
              </div>
              <!-- Start::información de despacho a domicilio -->
              <div class="col-12 py-0">
                <ul class="list-group lista_despacho">
                  <li
                    *ngIf="direccionDespacho"
                    class="list-group-item"
                    tooltip="Dirección de entrega "
                  >
                    <div class="row" style="color: #0063b9">
                      <div class="col-12 py-0" style="color: #0063b9">
                        <i
                          class="fas fa-truck"
                          style="margin-right: 10px; color: #0063b9"
                        ></i>
                        {{ direccionDespacho.street }} #{{
                          direccionDespacho.number
                        }}, depto/casa:
                        {{ direccionDespacho.departmentHouse }},
                        {{ direccionDespacho.city }}
                      </div>
                    </div>
                  </li>

                  <li class="list-group-item" tooltip="Persona que recibe ">
                    <div class="row">
                      <div class="col-12 py-0" style="color: #0063b9">
                        <span style="font-weight: bold"
                          >PERSONA QUE RECIBE</span
                        >
                      </div>
                      <div class="col-12 py-0" style="color: #0063b9">
                        <span *ngIf="recibe && recibe.company">
                          <!-- <i class="fa-solid fa-circle-check" style="color: #118565"></i> -->
                          <i
                            class="fas fa-people-carry"
                            style="margin-right: 10px; color: #0063b9"
                          ></i
                          >{{ recibe.company }}
                        </span>
                        <span *ngIf="!recibe || !recibe.company">
                          <!-- <i class="fa-solid fa-circle-check" style="color: #118565"></i> -->
                          <i
                            class="fas fa-people-carry"
                            style="margin-right: 10px; color: #0063b9"
                          ></i>
                          Titular de la compra
                        </span>
                      </div>
                    </div>
                  </li>
                  <li
                    *ngFor="let item of fechas_entregas; let i = index"
                    class="list-group-item"
                    tooltip="Fecha de entrega "
                  >
                    <div class="row">
                      <div class="col-12 py-0">
                        <span style="font-weight: bold; color: #0063b9"
                          >FECHA DE ENTREGA {{ i + 1 }}/{{
                            fechas_entregas.length
                          }}</span
                        >
                      </div>
                      <div class="col-12 py-0" style="color: #0063b9">
                        <i
                          class="fa-solid fa-calendar-days"
                          style="margin-right: 10px; color: #0063b9"
                        ></i>
                        {{
                          item
                            ? (item | date : 'EEEE dd MMMM, y ')
                            : ('' | titlecase)
                        }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- Start::configurar boleta o factura (desktop) -->
              <div class="col-12 py-0" style="margin-top: 1rem">
                <!-- Start::tipo de documento (desktop) -->
                <div
                  class="list-group-item"
                  tooltip="Tipo de Documento"
                  style="margin-bottom: 1rem"
                >
                  <div class="row">
                    <div class="col-12 py-0">
                      <span style="font-weight: bold; color: #0063b9"
                        >TIPO DE DOCUMENTO</span
                      >
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedDocument"
                        placeholder="Seleccionar documento..."
                        notFoundText="No se han encontrado giros"
                        [loading]="cargandoGiros"
                        [disabled]="cargandoGiros"
                        [clearable]="false"
                      >
                        <ng-option
                          *ngFor="let document of documentOptions"
                          [value]="document.id"
                          >{{ document.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <!-- End::tipo de documento (desktop) -->

                <!-- Start::giro (desktop) -->
                <div
                  class="list-group-item"
                  tooltip="Giros"
                  style="margin-bottom: 1rem"
                  *ngIf="
                    selectedDocument === invoiceType.INVOICE &&
                    !userSession.businessLine
                  "
                >
                  <div class="row">
                    <div class="col-12 py-0">
                      <span style="font-weight: bold; color: #0063b9"
                        >GIROS</span
                      >
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedGiro"
                        placeholder="Seleccionar giro..."
                        [loading]="cargandoGiros"
                        loadingText="Cargando giros'"
                      >
                        <ng-option
                          *ngFor="let giro of girosOptions"
                          [value]="giro.code"
                          >{{ giro.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <!-- End::giro (desktop) -->
              </div>
              <!-- End::configurar boleta o factura (desktop) -->
            </div>
            <!-- End::despacho a domicilio (desktop) -->

            <!-- Start::retiro en tienda (mobile) -->
            <div
              *ngIf="
                cartSession.shipment?.deliveryMode == 'pickup' && tiendaRetiro
              "
              class="row block_despacho"
            >
              <div
                class="col-12 py-0"
                style="flex-direction: column; justify-content: center"
              >
                <div
                  style="
                    color: #0063b9;
                    font-size: small;
                    font-weight: bold;
                    padding-left: 10px;
                    border-left: 1px solid #005db9;
                    border-right: 1px solid #005db9;
                    border-radius: 0px;
                    border-top: 1px solid #005db9;
                  "
                >
                  <div
                    class="row"
                    style="padding-top: 10px; margin-bottom: -5px"
                  >
                    <div class="ms-1 col-12 py-0 flex justify-content-start">
                      {{ tiendaRetiro.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 py-0">
                <ul class="list-group lista_despacho">
                  <li class="list-group-item" tooltip="Fecha de entrega ">
                    <div class="row">
                      <div class="col-12 py-0" style="color: #0063b9">
                        <i class="fas fa-store-alt" style="color: #0063b9"></i>
                        {{ tiendaRetiro.address || '' | titlecase }}
                      </div>
                    </div>
                  </li>

                  <li
                    *ngIf="recibe"
                    class="list-group-item"
                    tooltip="Persona que recibe "
                  >
                    <div class="row">
                      <div class="col-12 py-0">
                        <span style="font-weight: bold; color: #0063b9"
                          >RETIRA EN TIENDA</span
                        >
                      </div>
                      <div class="col-12 py-0" style="color: #0063b9">
                        <span>
                          <i
                            class="fas fa-people-carry"
                            style="color: #0063b9"
                          ></i>
                          {{
                            cartSession.observation ==
                            'Persona que recibe: Titular de la Venta'
                              ? 'Titular de la compra'
                              : (
                                  cartSession.observation ||
                                  'Recibe: Titular de la Venta'
                                )
                                  .split('Celular')[0]
                                  .split('Recibe:')[1]
                          }}</span
                        >
                      </div>
                    </div>
                  </li>
                  <li
                    *ngFor="let item of fechas_entregas; let i = index"
                    class="list-group-item"
                    tooltip="Fecha de entrega "
                  >
                    <div class="row">
                      <div class="col-12 py-0">
                        <span style="font-weight: bold; color: #0063b9"
                          >FECHA DE ENTREGA {{ i + 1 }}/{{
                            fechas_entregas.length
                          }}</span
                        >
                      </div>
                      <div class="col-12 py-0" style="color: #0063b9">
                        <i
                          class="fa-solid fa-calendar-days"
                          style="margin-right: 10px; color: #0063b9"
                        ></i>
                        {{
                          item
                            ? (item | date : 'EEEE dd MMMM, y ')
                            : ('' | titlecase)
                        }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 py-0" style="margin-top: 1rem">
                <div
                  class="list-group-item"
                  tooltip="Tipo de Documento"
                  style="margin-bottom: 1rem"
                >
                  <div class="row px-2">
                    <div class="col-12 py-0">
                      <span style="font-weight: bold; color: #0063b9"
                        >TIPO DE DOCUMENTO</span
                      >
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedDocument"
                        placeholder="Seleccionar documento..."
                        notFoundText="No se han encontrado giros"
                        [loading]="cargandoGiros"
                        [disabled]="cargandoGiros"
                        [clearable]="false"
                      >
                        <ng-option
                          *ngFor="let document of documentOptions"
                          [value]="document.id"
                          >{{ document.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div
                  class="list-group-item"
                  tooltip="Giros"
                  *ngIf="
                    selectedDocument === invoiceType.INVOICE &&
                    !userSession.businessLine
                  "
                  style="margin-bottom: 1rem"
                >
                  <div
                    class="row"
                    style="margin-left: -1.1rem; margin-right: -1.1rem"
                  >
                    <div class="col-12 py-0">
                      <span style="font-weight: bold; color: #0063b9"
                        >GIROS</span
                      >
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedGiro"
                        placeholder="Seleccionar giro..."
                        [loading]="cargandoGiros"
                        loadingText="Cargando giros'"
                      >
                        <ng-option
                          *ngFor="let giro of girosOptions"
                          [value]="giro.code"
                          >{{ giro.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div
                  class="list-group-item"
                  tooltip="Dirección"
                  *ngIf="selectedDocument === invoiceType.INVOICE && guest"
                >
                  <div class="col-12 py-0" style="padding: 0 !important">
                    <app-map
                      title="DIRECCIÓN"
                      (clearAddress)="clearAddress()"
                      [storeAddress]="tienda?.direccion || ''"
                      [storeZone]="tienda?.zona || ''"
                      [autocompletado]="autocompletado"
                      (changeAddress)="setAddress($event)"
                      (changeCoordinates)="geolocalizacion($event)"
                    />
                  </div>
                  <form [formGroup]="formDireccion">
                    <div
                      class="row g-3"
                      style="margin-top: 1rem; margin-left: 0.1rem"
                    >
                      <div
                        class="mb-2 col-12 py-0"
                        style="padding: 0 !important"
                      >
                        <label>Calle (*)</label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="calle"
                          (blur)="cargarDireccion()"
                        />
                      </div>

                      <div
                        class="mb-2 col-12 py-0"
                        style="padding: 0 !important"
                      >
                        <label for="inputPassword4">Número</label>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="numero"
                          (blur)="cargarDireccion()"
                          maxLength="9"
                          min="1"
                          max="999999999"
                          appPhoneChar
                        />
                      </div>
                      <!--<div class="mb-3 col-md-6">
                        <label>Departamento</label>
                        <input type="text" class="form-control" formControlName="depto" (blur)="cargarDireccion()" />
                      </div> -->

                      <div
                        class="mb-3 col-12 py-0"
                        style="padding: 0 !important"
                      >
                        <label>Comuna (*)</label>
                        <ng-select
                          [clearable]="false"
                          [searchable]="true"
                          [items]="cities"
                          bindLabel="city"
                          bindValue="id"
                          formControlName="comuna"
                          class="form-control-select form-control"
                          placeholder="Comuna*"
                          (blur)="cargarDireccion()"
                          (change)="obtenerLocalidades($event)"
                        >
                        </ng-select>
                      </div>

                      <div class="mb-3 col-12 py-0" hidden>
                        <label for="inputPassword4">Localización (*)</label>
                        <div *ngIf="!localidades">
                          <p>Seleccione una comuna para ver localidades</p>
                        </div>
                        <div *ngIf="localidades">
                          <ng-select
                            [clearable]="false"
                            [searchable]="true"
                            [items]="localidades"
                            bindLabel="localidad"
                            bindValue="localidad"
                            formControlName="localizacion"
                            class="form-control-select form-control"
                            placeholder="Comuna*"
                            (change)="cargarDireccion()"
                            (blur)="cargarDireccion()"
                          >
                          </ng-select>
                        </div>
                      </div>
                      <!--
                      <div class="mb-3 col-md-12">
                        <label for="validationTextarea">Referencia</label>
                        <textarea
                          class="form-control"
                          placeholder="Ingrese referencia para su direccion"
                          formControlName="referencia"
                        ></textarea>
                      </div>-->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- End::retiro en tienda (mobile) -->
          </div>
        </div>
      </div>
      <div
        class="col-xl-3 col-lg-3 col-md-6"
        style="
          min-width: 30%;
          padding: 15px;
          background-color: #e3e3e3;
          margin-right: 10px;
        "
      >
        <div class="card h-100">
          @if(countryCode=== 'cl'){
          <div
            class="card-header"
            *ngIf="!alertCartShow"
            style="color: #0063b9"
          >
            Selecciona medio de pago
          </div>
          }
          <div class="card-body">
            <app-loading-element
              *ngIf="loadingPage"
              [text]="loadingText"
            ></app-loading-element>

            <!-- <div *ngIf="guest">
              <div class="row">
                <div style="margin-bottom: 10px; padding: 5px">
                  <div class="card-body m-0">
                    <form [formGroup]="formVisita">
                      <div class="row">
                        <div class="col-sm-12" style="margin-bottom: 11px">
                          <h4 class="card-title" style="color: #005db9">
                            {{ config.document.name }} *
                          </h4>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              type="text"
                              formControlName="rut"
                              class="form-control"
                              [placeholder]="config.document.name + '*'"
                              formatRut
                              (blur)="onBlur()"
                            />

                            <p
                              *ngIf="
                              formVisita.controls['rut'].errors?.['invalidRut'] &&
                              formVisita.controls['rut'].touched
                              "
                              class="text-error-form-2 pull-right"
                            >
                              El {{ config.document.name }} ingresado no es
                              válido.
                            </p>
                            <p
                              *ngIf="isInvoice"
                              class="text-error-form-2 pull-right"
                            >
                              Debes ingresar el {{ config.document.name }} de
                              empresa.
                            </p>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              formControlName="nombre"
                              type="text"
                              class="form-control"
                              placeholder="Nombres*"
                              appLettersChar
                            />
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              formControlName="apellido"
                              type="text"
                              class="form-control"
                              placeholder="Apellidos*"
                              appLettersChar
                            />
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">{{
                                  config.phoneCodes.mobile.code
                                }}</span>
                              </div>
                              <input
                                formControlName="telefono"
                                type="text"
                                class="form-control"
                                placeholder="Teléfono*"
                                maxLength="8"
                                min="1"
                                max="99999999"
                              />
                            </div>

                            <p
                              *ngIf="
                                formVisita.controls['telefono'].invalid &&
                                formVisita.controls['telefono'].touched
                              "
                              class="text-error-form-2"
                            >
                              El Teléfono ingresado no es válido
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> -->
            <ng-container *ngIf="alertCartShow && alertCart">
              <div class="alert-cart">
                <div class="row" class="flex justify-content-center mb-3">
                  <div class="col-12 py-0" class="text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      fill="currentColor"
                      class="bi bi-exclamation-circle"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                      />
                      <path
                        d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                      />
                    </svg>
                  </div>
                </div>
                <h4 class="text-red-500 text-center">
                  {{
                    rejectedCode != -11
                      ? 'Pago Rechazado'
                      : alertCart?.detalleMensaje
                  }}
                </h4>
                <ng-container *ngIf="rejectedCode != -11" class="mb-5">
                  <div class="row">
                    @if(countryCode=='cl'){
                    <div class="col-12 py-0 text-center fw-bold">
                      <p *ngIf="alertCart?.detalleMensaje">
                        {{ alertCart?.detalleMensaje }}
                      </p>
                    </div>
                    } @else{

                    <div class="col-12 text-center fw-bold">
                      <p *ngIf="alertCart?.pedido">
                        {{ alertCart?.pedido }}
                      </p>
                      <p *ngIf="alertCart?.fecha">
                        Fecha: {{ alertCart?.fecha }}
                      </p>
                      <p *ngIf="alertCart?.detalleMensaje">
                        {{ alertCart?.detalleMensaje }}
                      </p>
                    </div>

                    }
                  </div>

                  <div
                    class="row mb-3"
                    *ngIf="
                      alertCart?.proceso != 'Anulado' &&
                      !alertCart?.pagoValidado
                    "
                  >
                    <div
                      class="col-12 py-0 text-justify"
                      style="font-size: 14px; font-weight: 600"
                    >
                      Si su dinero fue descontado será reversado en la proximas
                      horas.
                    </div>
                  </div>
                </ng-container>

                <div
                  class="col-12 py-0"
                  class="text-center"
                  *ngIf="!alertCart?.pagoValidado"
                >
                  <button
                    name="Volver"
                    class="btn btn-lg btn-border-primary"
                    (click)="intentarPagoNuevamente()"
                  >
                    Volver a intentarlo
                  </button>
                </div>
              </div>
              <div
                class="col-12 p-0 text-center"
                *ngIf="
                  !alertCart?.pagoValidado ||
                  alertCart?.mostrarBotonVolverIntentar
                "
              ></div>
            </ng-container>

            <ng-container *ngIf="!alertCartShow">
              <ng-container *ngIf="documentType == 'factura'">
                <div *ngIf="guest" class="row-pagos">
                  @if(countryCode=== 'cl'){
                  <div
                    *ngFor="let item of paymentMethods"
                    class="col-12 py-0"
                    style="margin-bottom: 3px"
                    [class.mb-2]="innerWidth < 450"
                  >
                    <div
                      id="pagos_weypaid"
                      class="block-payment"
                      [ngClass]="{
                        active: this.paymentMethodActive == item.code
                      }"
                      (click)="activepaymentMethod(item)"
                    >
                      <div
                        class="col-2 py-0 flex justify-content-center align-items-center"
                      >
                        <div class="form-check">
                          <!--icon pago-->
                          <i
                            class="fa-sharp fa-solid fa-circle-check"
                            style="font-size: 20px"
                            [ngStyle]="{
                              color:
                                paymentMethodActive === item.code
                                  ? '#118565'
                                  : '#D1D1D1'
                            }"
                          ></i>
                        </div>
                      </div>
                      <div class="col-10 py-0">
                        <span style="color: black">
                          <img
                            *ngIf="item.iconImage"
                            [src]="item.iconImage"
                            class="methodPaymentLogo"
                          />
                          <label *ngIf="!item.iconImage">{{
                            item.name | titlecase
                          }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  } @else{
                  <div>
                    <img
                      src="../../../../../assets/img/Banner-Compra-1.png"
                      alt="MDN"
                      width="280"
                    />
                  </div>
                  }
                </div>
                <div *ngIf="!guest" class="row-pagos">
                  @if(countryCode=== 'cl'){
                  <div
                    *ngFor="let item of paymentMethods"
                    class="col-12 py-0"
                    style="margin-bottom: 3px"
                    [class.mb-2]="innerWidth < 450"
                  >
                    <div
                      class="block-payment"
                      [ngClass]="{
                        active: this.paymentMethodActive == item.code
                      }"
                      (click)="activepaymentMethod(item)"
                    >
                      <div
                        class="col-2 py-0 flex justify-content-center align-items-center"
                      >
                        <div class="form-check">
                          <!--icon pago-->
                          <i
                            class="fa-sharp fa-solid fa-circle-check"
                            style="font-size: 20px"
                            [ngStyle]="{
                              color:
                                paymentMethodActive === item.code
                                  ? '#118565'
                                  : '#D1D1D1'
                            }"
                          ></i>

                          <label></label>
                        </div>
                      </div>

                      <div class="col-10 py-0 text-center">
                        <span>
                          <i
                            *ngIf="item.iconImage"
                            [class]="item.iconImage"
                          ></i>
                          <img
                            *ngIf="item.iconImage"
                            [src]="item.iconImage"
                            [alt]="item.code"
                            class="methodPaymentLogo"
                          />
                          <label *ngIf="!item.iconImage">{{
                            item.name | titlecase
                          }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  } @else{
                  <div>
                    <img
                      src="../../../../../assets/img/Banner-Compra-1.png"
                      alt="MDN"
                      width="280"
                    />
                  </div>
                  }
                </div>

                @if(countryCode=== 'cl'){
                <form
                  [formGroup]="formOv"
                  *ngIf="formOv && paymentMethodActive == 'ordenCompra'"
                >
                  <div class="row mt-2">
                    <div class="mb-1 col-6 py-0">
                      <label>Número orden de compra</label>
                      <input
                        formControlName="number"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Ingrese el número de OC"
                      />
                    </div>
                    <hr />
                    <div class="mb-1 col-6 py-0">
                      <label>Monto orden de compra</label>
                      <input
                        formControlName="amount"
                        class="form-control form-control-lg"
                        type="number"
                        placeholder="Ingrese el monto de su OC"
                      />
                    </div>
                    <div
                      class="mb-1 py-0"
                      [class.col-sm-12]="centrosCosto.length > 0"
                      [class.col-12]="centrosCosto.length == 0"
                    >
                      <label>Seleccione la orden de compra</label>
                      <div class="row">
                        <div class="col-12 py-0 flex justify-content-start">
                          <label
                            [for]="idArchivo"
                            [ngStyle]="{
                              cursor: userSession.creditLine
                                ?.requiresConfirmation
                                ? 'not-allowed'
                                : 'pointer'
                            }"
                            [class.disabled]="
                              userSession.creditLine?.requiresConfirmation
                            "
                            class="btn btn-sm btn-primary me-2"
                            >Seleccionar Archivo</label
                          >
                          <input
                            type="file"
                            #idArchivoInput
                            [id]="idArchivo"
                            [disabled]="
                              userSession.creditLine?.requiresConfirmation
                            "
                            (change)="onFileChange($event)"
                            style="display: none"
                          />
                        </div>
                      </div>
                      <div class="row mt-12" *ngIf="archivo">
                        <div
                          class="col-10 py-0 text-start text-truncate"
                          style="font-size: 0.85rem"
                        >
                          <i
                            [class]="archivo.icon + ' me-2'"
                            style="font-size: 1.33333em"
                          ></i>
                          {{ archivo.nombre }}
                        </div>
                        <label
                          class="btn btn-sm btn-min_pad p-0 m-0"
                          (click)="eliminaArchivo()"
                        >
                          <i class="fas fa-trash-alt text-red-500"></i>
                        </label>
                      </div>
                    </div>

                    <div
                      class="mb-1 col-12 py-0"
                      *ngIf="centrosCosto.length > 0"
                    >
                      <label
                        >Centro de costo
                        <a (click)="openModalCentroCosto()"
                          ><i
                            class="fa-solid fa-square-plus"
                            style="
                              color: #0063b9;
                              margin-left: 10px;
                              cursor: pointer;
                              font-size: 20px;
                            "
                          ></i>
                        </a>
                      </label>
                      <select
                        class="form-control form-control-lg"
                        formControlName="costCenter"
                      >
                        <option [value]="''">
                          Seleccione centro de costo
                        </option>
                        <option
                          *ngFor="let item of centrosCosto"
                          [value]="item.code"
                        >
                          {{ item.code }} - {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <hr />
                    <div
                      class="mb-1 col-12 py-0"
                      *ngIf="centrosCosto.length == 0"
                    >
                      <label
                        >Si desea añadir el centro de costo, haz clic en el
                        siguiente icono
                        <a (click)="openModalCentroCosto()"
                          ><i
                            class="fa-solid fa-square-plus"
                            style="
                              color: #0063b9;
                              margin-left: 10px;
                              cursor: pointer;
                              font-size: 20px;
                            "
                          ></i>
                        </a>
                      </label>
                    </div>
                  </div>
                </form>

                <div class="mt-2 mb-1" *ngIf="clienteBloqueado">
                  <p>No es posible pagar con línea de crédito</p>
                  <div>
                    <b>Estado: </b
                    ><span class="text-red-500"><b>BLOQUEADO</b></span
                    ><br />
                    <span *ngIf="bloqueoCliente != null">
                      <b>Motivo: </b>{{ bloqueoCliente }}
                    </span>
                  </div>
                </div>

                <div class="mt-2 mb-1" *ngIf="getBloqueoError">
                  <p>
                    Recargue nuevamente la página para validar si tiene
                    habilitada su línea de crédito.
                  </p>
                </div>

                <div class="row" *ngIf="paymentMethodActive == 'sinDefinir'">
                  <p class="text-center subtitle w-100 text-red-500">
                    * Ha indicado que el supervisor al momento de aprobar la
                    compra, seleccionará la forma de pago.
                  </p>
                </div>

                }
              </ng-container>

              <ng-container *ngIf="documentType == 'cotizacion'">
                <div class="w-100 text-center mt-5">
                  <i class="far fa-file-pdf text-blue"></i>
                  <p class="text-center subtitle w-100 text-blue">
                    Ha elegido generar una cotización, presione el boton
                    continuar si esta seguro.
                  </p>
                  <button
                    type="button"
                    name="finishQuotation"
                    class="btn btn-outline-primary"
                    (click)="finishQuotation()"
                  >
                    Confirmar
                  </button>
                  <button
                    type="button"
                    name="cancelarQuotation"
                    class="btn btn-outline-warning"
                    (click)="documentType = 'factura'"
                  >
                    Cancelar
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div
            class="row text-primary"
            *ngIf="
              documentType != 'cotizacion' &&
              paymentMethodActive != 'ordenCompra' &&
              userSession.userRole !== 'compradorb2c' &&
              !guest
            "
          >
            @if(countryCode=== 'cl'){
            <div class="col-12 py-0 text-end button-container">
              <div
                class="cotizacionBtn"
                (click)="setDocumentType('cotizacion')"
              >
                <i class="fas fa-arrow-down"></i>
                Obtener cotización
                <i class="fas fa-file-invoice-dollar"></i>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </ng-container>
    <!-- End::despacho a domicilio o retiro en tienda (desktop) -->

    <!-- Start::forma de pago (mobile) -->
    <ng-container *ngIf="innerWidth < 450">
      <div class="container">
        <div
          class="cart-address-container ms-3 col-12 pt-3 pb-2 ps-2"
          style="color: #0063b9; margin-bottom: 10px"
          [ngStyle]="{ width: innerWidth > 450 ? '96%' : '92%' }"
        >
          <div class="row">
            <div
              class="col-2 py-0 flex justify-content-center"
              tyle=" color: #0063b9"
            >
              <i
                class="fa-solid fa-cart-shopping"
                style="font-size: 21px !important; color: #0063b9"
              ></i>
            </div>
            <div class="col-10 py-0">
              <p
                style="font-weight: bold; margin-bottom: 5px"
                [ngStyle]="{ 'font-size': innerWidth < 450 ? '16px' : '18px' }"
              >
                Carro de compra
              </p>
              <ng-container *ngIf="items.length > 1">
                <font style="font-weight: normal"
                  >({{ ' ' + items.length + ' PRODUCTOS' + ' ' }})</font
                >
              </ng-container>
              <ng-container *ngIf="items.length == 1">
                <font style="font-weight: normal"
                  >({{ ' ' + items.length + ' PRODUCTO' + ' ' }})</font
                >
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="xl:col-4 lg:col-4 md:col-6" [class.mb-3]="innerWidth < 450">
        <div class="card h-100">
          <div
            class="card-header ms-4"
            *ngIf="!alertCartShow"
            style="color: #005db9"
          >
            Seleccione su forma de pago
          </div>
          <div class="card-body">
            <app-loading-element
              *ngIf="loadingPage"
              [text]="loadingText"
            ></app-loading-element>

            <!-- <div *ngIf="guest">
              <div class="row">
                <div
                  class="card shadow-none"
                  style="
                    margin-bottom: 10px;
                    padding-left: 30px;
                    padding-right: 30px;
                  "
                >
                  <div class="card-body m-0">
                    <h4 class="card-title">
                      Ingrese su {{ config.document.name }}
                    </h4>
                    <form [formGroup]="formVisita">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              type="text"
                              formControlName="rut"
                              class="form-control"
                              [placeholder]="config.document.name + '*'"
                              formatRut
                            />

                            <p
                              *ngIf="
                              formVisita.controls['rut'].errors?.['invalidRut'] &&
                              formVisita.controls['rut'].touched
                              "
                              class="text-error-form-2 pull-right"
                            >
                              El {{ config.document.name }} ingresado no es
                              válido.
                            </p>
                            <p
                              *ngIf="isInvoice"
                              class="text-error-form-2 pull-right"
                            >
                              Debes ingresar el {{ config.document.name }} de
                              empresa.
                            </p>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              formControlName="nombre"
                              type="text"
                              class="form-control"
                              placeholder="Nombres*"
                              appLettersChar
                            />
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <input
                              formControlName="apellido"
                              type="text"
                              class="form-control"
                              placeholder="Apellidos*"
                              appLettersChar
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">{{
                                  config.phoneCodes.mobile.code
                                }}</span>
                              </div>
                              <input
                                formControlName="telefono"
                                type="text"
                                class="form-control"
                                placeholder="Teléfono*"
                                maxLength="8"
                                min="1"
                                appPhoneChar
                              />
                            </div>

                            <p
                              *ngIf="
                                formVisita.controls['telefono'].invalid &&
                                formVisita.controls['telefono'].touched
                              "
                              class="text-error-form-2"
                            >
                              El Teléfono ingresado no es válido
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> -->
            <ng-container *ngIf="alertCartShow && alertCart">
              <div class="row" class="flex justify-content-center mb-3">
                <div class="col-12 py-0" class="text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    fill="currentColor"
                    class="bi bi-exclamation-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                    />
                  </svg>
                </div>
              </div>
              <div class="alert-cart">
                <h4 class="text-red-500 text-center">
                  {{
                    rejectedCode != -11
                      ? 'Pago Rechazado'
                      : alertCart?.detalleMensaje
                  }}
                </h4>

                <ng-container *ngIf="rejectedCode != -11" class="mb-5">
                  <div class="row">
                    @if(countryCode=='cl'){
                    <div class="col-12 py-0 text-center fw-bold">
                      <p *ngIf="alertCart?.detalleMensaje">
                        {{ alertCart?.detalleMensaje }}
                      </p>
                    </div>
                    } @else{

                    <div class="col-12 text-center fw-bold">
                      <p *ngIf="alertCart?.pedido">
                        {{ alertCart?.pedido }}
                      </p>
                      <p *ngIf="alertCart?.fecha">
                        Fecha: {{ alertCart?.fecha }}
                      </p>
                      <p *ngIf="alertCart?.detalleMensaje">
                        {{ alertCart?.detalleMensaje }}
                      </p>
                    </div>

                    }
                  </div>

                  <div
                    class="row mb-1"
                    *ngIf="
                      alertCart?.proceso != 'Anulado' &&
                      !alertCart?.pagoValidado
                    "
                  >
                    <div
                      class="col-12 py-0 text-justify"
                      style="font-size: 13px; font-weight: 600"
                    >
                      Si su dinero fue descontado será reversado en la proximas
                      horas.
                    </div>
                  </div>
                </ng-container>

                <div
                  class="col-12 py-0"
                  class="text-center"
                  *ngIf="!alertCart?.pagoValidado"
                >
                  <button
                    name="Volver"
                    class="btn btn-sm btn-border-primary"
                    (click)="intentarPagoNuevamente()"
                  >
                    Volver a intentarlo
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!alertCartShow">
              <ng-container *ngIf="documentType == 'factura'">
                <div class="row justify-content-center">
                  <div class="mb-1 col-11 py-0">
                    <div *ngIf="guest" class="row mt-2">
                      @if(countryCode=='cl'){
                      <div
                        *ngFor="let item of paymentMethods"
                        class="col-12 py-0"
                        [class.mb-1]="innerWidth < 450"
                      >
                        <div
                          id="pagos_weypaid"
                          class="block-payment"
                          [ngClass]="{
                            active: this.paymentMethodActive == item.code
                          }"
                          (click)="activepaymentMethod(item)"
                        >
                          <div
                            class="col-1-pagos flex justify-content-center align-items-center"
                          >
                            <div class="form-check">
                              <div class="form-check">
                                <!--icon pago-->
                                <i
                                  class="fa-sharp fa-solid fa-circle-check"
                                  style="font-size: 20px"
                                  [ngStyle]="{
                                    color:
                                      paymentMethodActive === item.code
                                        ? '#118565'
                                        : '#D1D1D1'
                                  }"
                                ></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 py-0">
                            <span>
                              <img
                                *ngIf="item.iconImage"
                                [alt]="item.code"
                                [src]="item.iconImage"
                                class="lazyload methodPaymentLogo"
                              />
                              <label
                                class="text-center"
                                *ngIf="!item.iconImage"
                                >{{ item.name | titlecase }}</label
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                      } @else{
                      <div>
                        <img
                          src="../../../../../assets/img/Banner-Compra-1.png"
                          alt="MDN"
                          width="280"
                        />
                      </div>
                      }
                    </div>
                    <div *ngIf="!guest" class="row ion-justify-content-center">
                      @if(countryCode=='cl'){
                      <div
                        *ngFor="let item of paymentMethods"
                        class="col-6 py-0"
                        [class.mb-2]="innerWidth < 450"
                      >
                        <div
                          id="pagos_weypaid"
                          class="block-payment"
                          [ngClass]="{
                            active: this.paymentMethodActive == item.code
                          }"
                          (click)="activepaymentMethod(item)"
                        >
                          <div
                            class="col-2 py-0 flex justify-content-center align-items-center"
                          >
                            <div class="form-check">
                              <i
                                class="fa-sharp fa-solid fa-circle-check"
                                style="font-size: 20px"
                                [ngStyle]="{
                                  color:
                                    paymentMethodActive === item.code
                                      ? '#118565'
                                      : '#D1D1D1'
                                }"
                              ></i>
                            </div>
                          </div>

                          <div class="col-10 py-0">
                            <span>
                              <img
                                *ngIf="item.iconImage"
                                [src]="item.iconImage"
                                [alt]="item.code"
                                class="methodPaymentLogo"
                              />
                              <label
                                class="text-center"
                                *ngIf="!item.iconImage"
                                >{{ item.name | titlecase }}</label
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                      } @else{
                      <div>
                        <img
                          src="../../../../../assets/img/Banner-Compra-1.png"
                          alt="MDN"
                          width="280"
                        />
                      </div>
                      }
                    </div>
                  </div>
                </div>

                <form
                  [formGroup]="formOv"
                  *ngIf="paymentMethodActive == 'ordenCompra'"
                >
                  <div class="row">
                    <div class="mb-1 col-6 py-0">
                      <label>Número orden de compra</label>
                      <input
                        formControlName="number"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Ingrese el número de OC"
                      />
                    </div>

                    <div class="mb-1 col-6 py-0">
                      <label>Monto orden de compra</label>
                      <input
                        formControlName="amount"
                        class="form-control form-control-lg"
                        type="number"
                        placeholder="Ingrese el monto de su OC"
                      />
                    </div>
                    <div class="mb-1 col-12 py-0">
                      <label>Seleccione la orden de compra</label>
                      <div class="row">
                        <div class="col-12 py-0 flex justify-content-start">
                          <label
                            [for]="idArchivo"
                            [ngStyle]="{
                              cursor: userSession.creditLine
                                ?.requiresConfirmation
                                ? 'not-allowed'
                                : 'pointer'
                            }"
                            [class.disabled]="
                              userSession.creditLine?.requiresConfirmation
                            "
                            class="btn btn-sm btn-primary me-2"
                            >Seleccionar Archivo</label
                          >
                          <input
                            type="file"
                            #idArchivoMobileInput
                            [id]="idArchivoMobile"
                            [disabled]="
                              userSession.creditLine?.requiresConfirmation
                            "
                            (change)="onFileChange($event)"
                            style="display: none"
                          />
                        </div>
                      </div>
                      <div class="row mt-2" *ngIf="archivo">
                        <div
                          class="col-10 text-start text-truncate"
                          style="font-size: 0.85rem"
                        >
                          <i
                            [class]="archivo.icon + ' me-2'"
                            style="font-size: 1.33333em"
                          ></i>
                          {{ archivo.nombre }}
                        </div>
                        <label
                          class="btn btn-sm btn-min_pad p-0 m-0"
                          (click)="eliminaArchivo()"
                        >
                          <i class="fas fa-trash-alt text-red-500"></i>
                        </label>
                      </div>
                    </div>

                    <div class="mb-1 col-6 py-0">
                      <label>Centro de costo</label>
                      <select
                        class="form-control form-control-lg"
                        formControlName="costCenter"
                      >
                        <option [value]="''">
                          Seleccione centro de costo
                        </option>
                        <option
                          *ngFor="let item of centrosCosto"
                          [value]="item.code"
                        >
                          {{ item.code }} - {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </form>

                <div class="mb-3 px-3" *ngIf="clienteBloqueado">
                  <p>No es posible pagar con línea de crédito</p>
                  <div>
                    <b>Estado: </b
                    ><span class="text-red-500"><b>BLOQUEADO</b></span
                    ><br />
                    <span *ngIf="bloqueoCliente.nombreMotivoBloqueo != null">
                      <b>Motivo: </b>{{ bloqueoCliente.nombreMotivoBloqueo }}
                    </span>
                  </div>
                </div>

                <div class="px-3" *ngIf="getBloqueoError">
                  <p>
                    Recargue nuevamente la página para validar si tiene
                    habilitada su línea de crédito.
                  </p>
                </div>

                <div class="row" *ngIf="paymentMethodActive == 'sinDefinir'">
                  <p class="text-center subtitle w-100 text-red-500">
                    * Ha indicado que el supervisor al momento de aprobar la
                    compra, seleccionará la forma de pago.
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="documentType == 'cotizacion'">
                <div class="w-100 text-center mt-5">
                  <i class="far fa-file-pdf text-blue"></i>
                  <p class="text-center subtitle w-100 text-blue">
                    Ha elegido generar una cotización, presione el boton
                    continuar si esta seguro.
                  </p>
                  <button
                    type="button"
                    name="finishQuotation"
                    class="btn btn-outline-primary"
                    (click)="finishQuotation()"
                  >
                    Confirmar
                  </button>
                  <button
                    type="button"
                    name="cancelarQuotation"
                    class="btn btn-outline-warning"
                    (click)="documentType = 'factura'"
                  >
                    Cancelar
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div
            class="row text-primary mt-1 mb-2"
            *ngIf="
              documentType != 'cotizacion' &&
              paymentMethodActive != 'ordenCompra' &&
              userSession.userRole !== 'compradorb2c' &&
              !guest
            "
          >
            <div
              class="col-12 py-0 text-end"
              style="color: #0063b9 !important"
            >
              @if(countryCode=='cl'){
              <div
                class="cotizacionBtn"
                (click)="setDocumentType('cotizacion')"
              >
                Obtener cotización <i class="fas fa-file-invoice-dollar"></i>
              </div>

              }
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- End::forma de pago (mobile) -->

    <!-- Start::resumen de pedido (mobile y desktop) -->
    <div
      class="col-xl-4 col-lg-4 col-md-12"
      style="padding: 15px; background-color: #e3e3e3"
      [class.mt-4]="innerWidth < 1000 && innerWidth > 451"
      [class.mb-3]="innerWidth < 450"
    >
      <div class="me-1 card h-100">
        <div class="card-header" style="color: #0063b9">Resumen pedido</div>
        <div class="card-body">
          <app-detalle-carro-productos
            [shippingType]="cartSession.shipment?.deliveryMode"
            *ngIf="innerWidth < 450"
            [seePrices]="false"
          />
          <app-detalle-carro-productos
            [shippingType]="cartSession.shipment?.deliveryMode"
            *ngIf="innerWidth >= 450"
          />

          <!-- Start::botones anterior e ir a pagar (desktop) -->
          <ng-container *ngIf="innerWidth >= 450">
            @if(countryCode === 'cl'){
            <!-- Start:: -->
            <div class="row">
              <div
                class="col-12 py-0"
                *ngIf="cd_ver && userSession.creditLine?.requiresConfirmation"
              >
                <app-codigo-oc
                  [id]="cartSession._id"
                  [purchaseOrderId]="purchaseOrderId"
                  (verificar)="Confirmar($event)"
                  (renv_cod)="paymentOvSms()"
                ></app-codigo-oc>
              </div>
            </div>
            <!-- End:: -->
            } @if(countryCode=== 'pe'){
            <div class="row m-0">
              <div class="mt-3">
                <p>
                  <input type="checkbox" [formControl]="isActive" />
                  Acepto

                  <a
                    [routerLink]="['/sitio/politicas/terminos-condiciones']"
                    target="_blank"
                    rel="nofollow"
                  >
                    términos y condiciones
                  </a>
                </p>
              </div>
            </div>

            }

            <div class="row m-0">
              <!-- Start:: botón anterior (desktop) -->
              <div class="mt-2 col-6 py-0 px-1" *ngIf="!cd_ver">
                <a
                  [routerLink]="['/', 'carro-compra', 'metodo-de-envio']"
                  class="btn btn-border-primary text-sm w-100 btn-lg text-center"
                >
                  <i
                    class="fas fa-chevron-left"
                    style="margin-right: 10px"
                  ></i>
                  Anterior
                </a>
              </div>
              <!-- End:: botón anterior (desktop) -->

              @if(countryCode=== 'cl'){

              <!-- Start::botón ir a pagar (desktop) (ir a pagar1) -->
              <div class="mt-2 col-6 py-0 px-1">
                <button
                  name="paymentOv"
                  *ngIf="
                    !cd_ver &&
                    userSession.userRole != userRoleType.BUYER &&
                    !userSession.creditLine?.requiresConfirmation &&
                    !['webPay', 'mercadopago', 'khipu'].includes(
                      paymentMethodActive || ''
                    ) &&
                    !guest
                  "
                  (click)="paymentOv()"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    formOv.invalid ||
                    isVacio(paymentMethodActive) ||
                    isVacio(archivo) ||
                    loadingPage ||
                    !selectedDocument ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro)
                  "
                  class="btn btn-lg text-sm text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>

                <!-- Start::ir a pagar2 pago con sms-->
                <button
                  name="paymentOvSms"
                  *ngIf="
                    userSession.userRole != userRoleType.BUYER &&
                    userSession.creditLine?.requiresConfirmation &&
                    !cd_ver &&
                    !['webPay', 'mercadopago', 'khipu'].includes(
                      paymentMethodActive || ''
                    ) &&
                    !guest
                  "
                  (click)="paymentOvSms()"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    formOv.invalid ||
                    isVacio(paymentMethodActive) ||
                    loadingPage ||
                    !selectedDocument ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro)
                  "
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fa-solid fa-comment-sms"
                    style="margin-left: 3px"
                  ></i>
                </button>
                <!-- End::ir a pagar2 -->

                <!-- Start::ningún pago seleccionado siendo invitado (no tiene acción) (desktop) (ir a pagar3) -->
                <button
                  name="paymentwebpay2 "
                  [disabled]="true"
                  *ngIf="!paymentMethodActive && guest"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::ningún pago seleccionado siendo invitado (no tiene acción) (desktop) (ir a pagar3) -->

                <!-- Start::pagar con mercadopago (no comprador ni invitado) (desktop) (ir a pagar4)-->
                <button
                  name="paymentMercadopago"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    btnWebpayPost ||
                    alertCartShow ||
                    !selectedDocument ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro)
                  "
                  *ngIf="
                    userSession.userRole != userRoleType.BUYER &&
                    paymentMethodActive == 'mercadopago' &&
                    !guest
                  "
                  (click)="paymentMercadopago()"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con mercadopago (no comprador ni invitado) (desktop) (ir a pagar4) -->

                <!-- Start::pagar con mercadopago siendo invitado (desktop) (ir a pagar5)-->
                <button
                  *ngIf="guest && paymentMethodActive == 'mercadopago'"
                  name="paymentMercadopago2 "
                  [disabled]="
                    documentType == 'cotizacion' ||
                    !formVisita.valid ||
                    !validado ||
                    alertCartShow ||
                    btnWebpayPost ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro) ||
                    (guest &&
                      selectedDocument === invoiceType.INVOICE &&
                      (!formDireccion.valid || !tienda))
                  "
                  (click)="paymentMercadopago()"
                  class="btn btn-lg text-sm btn-secondary w-100 tex-tcenter"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con mercadopago siendo invitado (desktop) (ir a pagar5) -->

                <!-- Start::pagar con khipu (no comprador ni invitado) (desktop) (ir a pagar6) -->
                <button
                  name="paymentKhipu"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    btnWebpayPost ||
                    alertCartShow ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro)
                  "
                  *ngIf="
                    userSession.userRole != userRoleType.BUYER &&
                    paymentMethodActive == 'khipu' &&
                    !guest
                  "
                  (click)="paymentKhipu()"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con khipu (no comprador ni invitado) (desktop) (ir a pagar6) -->

                <!-- Start::pagar con khipu siendo invitado (desktop) (ir a pagar7) -->
                <button
                  name="paymentKhipu"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    !formVisita.valid ||
                    !validado ||
                    alertCartShow ||
                    btnWebpayPost ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro) ||
                    (guest &&
                      selectedDocument === invoiceType.INVOICE &&
                      (!formDireccion.valid || !tienda))
                  "
                  *ngIf="guest && paymentMethodActive == 'khipu'"
                  (click)="paymentKhipu()"
                  class="btn btn-lg text-sm btn-secondary w-100 tex-tcenter"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con khipu siendo invitado (desktop) (ir a pagar7) -->

                <!-- Start::pagar con webpay (no comprador ni invitado) (desktop) (ir a pagar8) -->
                <button
                  name="paymentWebpay"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    btnWebpayPost ||
                    alertCartShow ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro)
                  "
                  *ngIf="
                    userSession.userRole != userRoleType.BUYER &&
                    paymentMethodActive == 'webPay' &&
                    !guest
                  "
                  (click)="creteateTransactionTransBank()"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con webpay (no comprador ni invitado) (desktop) (ir a pagar8) -->

                <!-- Start::pagar con webpay siendo invitado (desktop) (ir a pagar9) -->
                <button
                  name="paymentwebpay2"
                  [disabled]="
                    documentType == 'cotizacion' ||
                    !formVisita.valid ||
                    !validado ||
                    alertCartShow ||
                    btnWebpayPost ||
                    (!userSession.businessLine &&
                      selectedDocument === invoiceType.INVOICE &&
                      !selectedGiro) ||
                    (guest &&
                      selectedDocument === invoiceType.INVOICE &&
                      (!formDireccion.valid || !tienda))
                  "
                  *ngIf="guest && paymentMethodActive == 'webPay'"
                  (click)="creteateTransactionTransBank()"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
                <!-- End::pagar con webpay siendo invitado (desktop) (ir a pagar9) -->

                <!-- Start::solicitar compra siendo comprador (desktop) -->
                <button
                  name="purchaseRequestAll "
                  *ngIf="
                    userSession.userRole == userRoleType.BUYER &&
                    paymentMethodActive != 'sinDefinir'
                  "
                  (click)="purchaseRequestAll()"
                  [disabled]="formOv.invalid || isVacio(archivo)"
                  class="btn btn-lg btn-secondary w-100 text-center"
                >
                  Solicitar Compra *
                </button>
                <!-- End::solicitar compra siendo comprador (desktop) -->

                <!-- Start::solicitar compra siendo comprador (desktop) -->
                <button
                  name="purchaseRequest "
                  *ngIf="
                    userSession.userRole == userRoleType.BUYER &&
                    paymentMethodActive == 'sinDefinir'
                  "
                  (click)="purchaseRequest()"
                  class="btn btn-lg text-sm btn-secondary w-100 text-center"
                >
                  Solicitar Compra *
                </button>
              </div>
              <!-- End::botón ir a pagar (desktop) (ir a pagar1)  -->

              <div class="mt-3 col-12 px-1">
                <em *ngIf="userSession.userRole == userRoleType.BUYER"
                  >* Se generará una solicitud de compra y debe ser aprobada
                  por tu supervisor antes de generar el pedido.
                </em>
              </div>

              } @else{
              <div class="mt-2 col-6 py-0 px-1">
                <!-- Start::botón ir a pagar (desktop) (ir a pagar NIUBIZ) -->

                <button
                  name="paymentNiubiz"
                  [disabled]="!isActive.value"
                  *ngIf="guest && paymentMethodActive == 'Niubiz'"
                  (click)="creteateTransactionNiubiz()"
                  class="btn btn-lg btn-secondary px-0 w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>

                <button
                  name="paymentNiubiz"
                  [disabled]="!isActive.value"
                  *ngIf="
                    userSession.userRole != userRoleType.BUYER &&
                    paymentMethodActive == 'Niubiz' &&
                    !guest
                  "
                  (click)="creteateTransactionNiubiz()"
                  class="btn btn-lg btn-secondary px-0 w-100 text-center"
                >
                  Ir a pagar
                  <i
                    class="fas fa-chevron-right"
                    style="margin-left: 10px"
                  ></i>
                </button>
              </div>
              <!-- End::pagar con niubiz siendo invitado (desktop) (ir a pagar NIUBIZ) -->
              }
            </div>
          </ng-container>
          <!-- End::botones anterior e ir a pagar (desktop) -->
        </div>
      </div>
    </div>
    <!-- End::resumen de pedido (mobile y desktop) -->

    <!-- Start::despacho a domicilio o retiro en tienda (mobile) -->
    <ng-container *ngIf="innerWidth < 450">
      <div class="xl:col-4 lg:col-4 md:col-6" [class.mb-3]="innerWidth < 450">
        <div
          class="card"
          [ngClass]="{ 'h-100': innerWidth >= 450 }"
          [ngStyle]="{
            'margin-bottom': showresumen == true ? '40px' : '20px'
          }"
        >
          <div class="card-body">
            <div
              class="card-header"
              style="display: inline-block; color: #005db9"
            >
              Información de retiro
            </div>

            <!-- Start::despacho a domicilio (mobile) -->
            <div
              *ngIf="cartSession.shipment?.deliveryMode != 'pickup'"
              class="row block_despacho"
            >
              <!-- Start::despacho -->
              <div
                class="col-12 py-0"
                style="flex-direction: column; justify-content: center"
              >
                <div
                  style="
                    color: #0063b9;
                    font-size: small;
                    font-weight: bold;
                    padding-left: 10px;
                    border-left: 1px solid #005db9;
                    border-right: 1px solid #005db9;
                    border-radius: 0px;
                    border-top: 1px solid #005db9;
                  "
                >
                  <div
                    class="row"
                    style="padding-top: 10px; margin-bottom: -5px"
                  >
                    <div class="ms-3 col-1 py-0"></div>
                    <div class="col-10 py-0">DESPACHO A DOMICILIO</div>
                  </div>
                </div>
              </div>
              <!-- End::despacho -->

              <div class="col-12 py-0">
                <ul class="list-group lista_despacho">
                  <!-- Start::despacho -->
                  <li
                    *ngIf="direccionDespacho"
                    class="list-group-item"
                    tooltip="Dirección de entrega "
                  >
                    <div class="row">
                      <div class="col-10 py-0 flex justify-content-start">
                        <div class="row" style="color: #005db9 !important">
                          <div class="col-12 py-0">
                            <i
                              class="fas fa-map-marked-alt"
                              style="color: #005db9 !important"
                            ></i>
                            {{ direccionDespacho.street }} #{{
                              direccionDespacho.number
                            }}, depto/casa:
                            {{ direccionDespacho.departmentHouse }},
                            {{ direccionDespacho.city }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- End::despacho -->

                  <!-- Start::tipo de documento -->
                  <li class="list-group-item" tooltip="Tipo de Documento ">
                    <div class="row">
                      <div
                        class="ms-3 col-1 py-0 flex justify-content-center align-items-center"
                      >
                        <i
                          class="fa-solid fa-circle-check"
                          style="color: #118565"
                        ></i>
                      </div>
                      <div class="col-10 py-0 flex justify-content-start">
                        <div class="row">
                          <div class="col-12 py-0">
                            <span style="font-weight: bold; color: #005db9"
                              >TIPO DE DOCUMENTO</span
                            >
                          </div>
                          <div class="col-12 py-0">
                            <p
                              *ngIf="!esBoleta"
                              style="color: #005db9; margin-bottom: -2px"
                            >
                              <i
                                class="fas fa-file-alt"
                                style="color: #005db9 !important"
                              ></i
                              >Factura
                            </p>
                            <p
                              *ngIf="esBoleta"
                              style="color: #005db9; margin-bottom: -2px"
                            >
                              <i
                                class="fas fa-file-alt"
                                style="color: #005db9 !important"
                              ></i>
                              Boleta
                              <a
                                *ngIf="esBoleta"
                                title="Si necesitas Factura Debes registrarte como Empresa"
                                [routerLink]="['/sitio', 'registro-usuario']"
                                style="color: #005db9 !important"
                                class="float-end"
                                >¿ Necesitas Factura ?</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- End::tipo de documento -->

                  <li class="list-group-item" tooltip="Persona que recibe ">
                    <div class="row">
                      <div
                        class="ms-3 col-1 py-0 flex justify-content-center align-items-center"
                      >
                        <i
                          class="fa-solid fa-circle-check"
                          style="color: #118565"
                        ></i>
                      </div>
                      <div class="col-10 py-0 flex justify-content-start">
                        <div class="row">
                          <div class="col-12 py-0">
                            <span
                              style="
                                font-weight: bold;
                                color: #005db9 !important;
                              "
                              >RECIBE</span
                            >
                          </div>
                          <div
                            class="col-12 py-0"
                            style="color: #005db9 !important"
                          >
                            <span *ngIf="recibe && recibe.company"
                              ><i
                                class="fas fa-people-carry"
                                style="color: #005db9 !important"
                              ></i>
                              {{ recibe.company }}
                            </span>
                            <span *ngIf="!recibe || !recibe.company"
                              ><i
                                class="fas fa-people-carry"
                                style="color: #005db9 !important"
                              ></i>
                              Titular de la compra
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <!-- Start::fecha entrega -->
                  <li
                    *ngFor="let item of fechas_entregas; let i = index"
                    class="list-group-item"
                    tooltip="Fecha de entrega "
                  >
                    <div class="row">
                      <div
                        class="ms-3 col-1 py-0 flex justify-content-center align-items-center"
                      >
                        <i
                          class="fa-solid fa-circle-check"
                          style="color: #118565"
                        ></i>
                      </div>
                      <div class="col-10 py-0 flex justify-content-start">
                        <div class="row">
                          <div class="col-12 py-0" style="color: #0063b9">
                            <span style="font-weight: bold"
                              >FECHA DE ENTREGA {{ i + 1 }}/{{
                                fechas_entregas.length
                              }}</span
                            >
                          </div>
                          <div class="col-12 py-0" style="color: #0063b9">
                            <i
                              class="fa-solid fa-calendar-days"
                              style="margin-right: 10px; color: #0063b9"
                            ></i>
                            {{
                              item
                                ? (item | date : 'EEEE dd MMMM, y ')
                                : ('' | titlecase)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- End::fecha entrega -->
                </ul>
              </div>
            </div>
            <!-- End::despacho a domicilio (mobile) -->

            <!-- Start::retiro en tienda (mobile) -->
            <div
              *ngIf="
                cartSession.shipment?.deliveryMode == 'pickup' && tiendaRetiro
              "
              class="row block_despacho"
            >
              <div class="col-12 py-0" style="color: #005db9 !important">
                <ul class="list-group lista_despacho">
                  <li
                    class="list-group-item"
                    tooltip="Fecha de entrega "
                    style="border-top: 1px solid #005db9"
                  >
                    <div class="row">
                      <div class="col-12 py-0 flex justify-content-start">
                        <div class="row">
                          <div class="col-12 py-0">
                            <span style="font-weight: bold; color: #005db9">{{
                              tiendaRetiro.name
                            }}</span>
                          </div>
                          <div
                            class="col-12 py-0"
                            style="color: #005db9 !important"
                          >
                            <i
                              class="fas fa-store-alt"
                              style="color: #005db9 !important"
                            ></i>
                            {{ tiendaRetiro.address | titlecase }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li
                    *ngIf="recibe"
                    class="list-group-item"
                    tooltip="Persona que recibe "
                  >
                    <div class="row">
                      <div class="col-12 py-0 flex justify-content-start">
                        <div class="row">
                          <div
                            class="col-12 py-0"
                            style="color: #005db9 !important"
                          >
                            <span style="font-weight: bold"
                              >RETIRA EN TIENDA</span
                            >
                          </div>
                          <div
                            class="col-12 py-0"
                            style="color: #005db9 !important"
                          >
                            <i
                              class="fas fa-people-carry"
                              style="color: #005db9 !important"
                            ></i>
                            <span>{{
                              cartSession.observation ==
                              'Persona que recibe: Titular de la Venta'
                                ? 'Titular de la compra'
                                : (cartSession.observation || '')
                                    .split('Celular')[0]
                                    .split('Recibe:')[1]
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    *ngFor="let item of fechas_entregas; let i = index"
                    class="list-group-item"
                    tooltip="Fecha de entrega "
                  >
                    <div class="row">
                      <!--
                      <div class="ms-3 col-1 flex justify-content-center align-items-center">
                        <i class="fa-solid fa-circle-check" style="color: #118565"></i>
                      </div> -->
                      <div class="col-12 py-0 flex justify-content-start">
                        <div class="row">
                          <div class="col-12 py-0" style="color: #0063b9">
                            <span style="font-weight: bold"
                              >FECHA DE ENTREGA {{ i + 1 }}/{{
                                fechas_entregas.length
                              }}</span
                            >
                          </div>
                          <div class="col-12 py-0" style="color: #0063b9">
                            <i
                              class="fa-solid fa-calendar-days"
                              style="margin-right: 10px; color: #0063b9"
                            ></i>
                            {{
                              item
                                ? (item | date : 'EEEE dd MMMM, y ')
                                : ('' | titlecase)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 py-0" style="margin-top: 1rem">
                <div
                  class="list-group-item"
                  tooltip="Tipo de Documento"
                  style="margin-bottom: 1rem"
                >
                  <div class="row">
                    <div
                      class="col-12 py-0"
                      style="color: #005db9 !important; font-size: 13px"
                    >
                      <span style="font-weight: bold">TIPO DE DOCUMENTO</span>
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedDocument"
                        placeholder="Seleccionar documento..."
                        notFoundText="No se han encontrado giros"
                        [loading]="cargandoGiros"
                        [disabled]="cargandoGiros"
                        [clearable]="false"
                      >
                        <ng-option
                          *ngFor="let document of documentOptions"
                          [value]="document.id"
                          >{{ document.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div
                  class="list-group-item"
                  tooltip="Giros"
                  style="margin-bottom: 1rem"
                  *ngIf="
                    selectedDocument === invoiceType.INVOICE &&
                    !userSession.businessLine
                  "
                >
                  <div class="row">
                    <div class="col-12 py-0">
                      <span style="font-weight: bold; color: #0063b9"
                        >GIROS</span
                      >
                    </div>
                    <div class="col-12 py-0">
                      <ng-select
                        [(ngModel)]="selectedGiro"
                        placeholder="Seleccionar giro..."
                        [loading]="cargandoGiros"
                        loadingText="Cargando giros'"
                      >
                        <ng-option
                          *ngFor="let giro of girosOptions"
                          [value]="giro.code"
                          >{{ giro.name }}</ng-option
                        >
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div
                  class="list-group-item"
                  tooltip="Dirección"
                  *ngIf="selectedDocument === invoiceType.INVOICE && guest"
                >
                  <div>
                    <app-map
                      title="DIRECCIÓN"
                      (clearAddress)="clearAddress()"
                      [storeAddress]="tienda?.direccion || ''"
                      [storeZone]="tienda?.zona || ''"
                      [autocompletado]="autocompletado"
                      (changeAddress)="setAddress($event)"
                      (changeCoordinates)="geolocalizacion($event)"
                    />
                  </div>
                  <form [formGroup]="formDireccion">
                    <div class="row g-3" style="margin-top: 1rem">
                      <div class="mb-2 col-12 py-0">
                        <label>Calle (*)</label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="calle"
                          (blur)="cargarDireccion()"
                        />
                      </div>

                      <div class="mb-2 col-12 py-0">
                        <label for="inputPassword4">Número</label>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="numero"
                          (blur)="cargarDireccion()"
                          maxLength="9"
                          min="1"
                          max="999999999"
                          appPhoneChar
                        />
                      </div>
                      <!--<div class="mb-3 col-md-6">
                        <label>Departamento</label>
                        <input type="text" class="form-control" formControlName="depto" (blur)="cargarDireccion()" />
                      </div> -->

                      <div class="mb-2 col-12 py-0">
                        <label>Comuna (*)</label>
                        <ng-select
                          [clearable]="false"
                          [searchable]="true"
                          [items]="cities"
                          bindLabel="city"
                          bindValue="id"
                          formControlName="comuna"
                          class="form-control-select form-control"
                          placeholder="Comuna*"
                          (blur)="cargarDireccion()"
                          (change)="obtenerLocalidades($event)"
                        >
                        </ng-select>
                      </div>

                      <div class="mb-2 col-6 py-0" hidden>
                        <label for="inputPassword4">Localización (*)</label>
                        <div *ngIf="!localidades">
                          <p>Seleccione una comuna para ver localidades</p>
                        </div>
                        <div *ngIf="localidades">
                          <ng-select
                            [clearable]="false"
                            [searchable]="true"
                            [items]="localidades"
                            bindLabel="localidad"
                            bindValue="localidad"
                            formControlName="localizacion"
                            class="form-control-select form-control"
                            placeholder="Comuna*"
                            (change)="cargarDireccion()"
                            (blur)="cargarDireccion()"
                          >
                          </ng-select>
                        </div>
                      </div>
                      <!--<div class="mb-3 col-md-12">
                        <label for="validationTextarea">Referencia</label>
                        <textarea
                          class="form-control"
                          placeholder="Ingrese referencia para su direccion"
                          formControlName="referencia"
                        ></textarea>
                      </div> -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- End::retiro en tienda (mobile) -->
          </div>
        </div>
      </div>
    </ng-container>
    <!-- End::despacho a domicilio o retiro en tienda (mobile) -->
  </div>
</div>

<!-- Start::resumen de tu compra (mobile) (no existe en desktop)-->
<ng-container *ngIf="innerWidth < 450">
  <div class="footer_page w-screen sticky" style="z-index: 900">
    <div class="card h-100" style="margin-top: 5px; margin-bottom: -13px">
      <div
        class="card-header"
        style="display: inline-block"
        (mousedown)="showresumen = !showresumen"
      >
        <div class="flex">
          <div
            class="col-9 py-0 text-justify"
            style="font-size: 16px; color: #0063b9"
          >
            <strong>Resumen de tu Compra</strong>
          </div>
          <div class="col-3 py-0">
            <i
              [class]="showresumen ? 'fas fa-angle-down' : 'fas fa-angle-up'"
            ></i>
          </div>
        </div>
      </div>
      <div *ngIf="!showresumen" class="card-body text-justify">
        <div class="dropcart__totals text-justify">
          <table>
            <tr style="font-size: 14px; color: #005db9">
              <th>Total</th>
              <td class="fw-bold">
                {{ cartService.total$ | async | currency }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      @if(countryCode=== 'pe'){
      <div class="row m-0">
        <div class="mt-3">
          <p>
            <input type="checkbox" [formControl]="isActive" />
            Acepto

            <a
              [routerLink]="['/sitio/politicas/terminos-condiciones']"
              target="_blank"
              rel="nofollow"
            >
              términos y condiciones
            </a>
          </p>
        </div>
      </div>
      }

      <ng-container *ngIf="showresumen != false">
        <div
          class="col-12 py-0"
          style="
            border: 1px solid;
            margin-top: 5px;
            margin-bottom: 5px;
            color: rgba(0, 0, 0, 0.1);
          "
        ></div>

        <div class="card-body text-justify" style="font-size: 14px">
          <app-detalle-carro-productos
            [shippingType]="cartSession.shipment?.deliveryMode"
            [seeProducts]="false"
          />
        </div>
      </ng-container>

      @if(countryCode == 'cl'){
      <app-codigo-oc
        *ngIf="cd_ver"
        [id]="cartSession._id"
        [purchaseOrderId]="purchaseOrderId"
        (verificar)="Confirmar($event)"
        (renv_cod)="paymentOvSms()"
      />

      <div class="row">
        <div class="mt-2 col-12 py-0 px-1">
          <!-- Start::ir a pagar (mobile) (ir a pagar10)  -->
          <button
            name="paymentOv "
            *ngIf="
              userSession.userRole != userRoleType.BUYER &&
              !userSession.creditLine?.requiresConfirmation &&
              !['webPay', 'mercadopago', 'khipu'].includes(
                paymentMethodActive || ''
              ) &&
              !guest
            "
            (click)="paymentOv()"
            [disabled]="
              documentType == 'cotizacion' ||
              formOv.invalid ||
              isVacio(paymentMethodActive) ||
              isVacio(archivo) ||
              loadingPage ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro)
            "
            class="btn btn-lg text-sm btn-secondary w-100 text-center"
          >
            Ir a pagar
            <i class="fas fa-chevron-right" style="margin-left: 10px"></i>
          </button>
          <!-- End::ir a pagar (mobile) (ir a pagar10) -->

          <!-- Start:: (ir a pagar11) -->
          <button
            name="paymentOvSms "
            *ngIf="
              userSession.userRole != userRoleType.BUYER &&
              userSession.creditLine?.requiresConfirmation &&
              !cd_ver &&
              paymentMethodActive != 'webPay' &&
              paymentMethodActive != 'mercadopago' &&
              !guest
            "
            (click)="paymentOvSms()"
            [disabled]="
              documentType == 'cotizacion' ||
              formOv.invalid ||
              isVacio(paymentMethodActive) ||
              loadingPage ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro)
            "
            class="btn btn-lg text-sm btn-secondary w-100 text-center"
          >
            Ir a pagar<i
              class="fa-solid fa-comment-sms"
              style="margin-left: 10px"
            ></i>
          </button>
          <!-- End::(ir a pagar11) -->

          <!-- Start::pagar con webpay (no comprador ni invitado) (mobile) (ir a pagar12) -->
          <button
            name="paymentWebpay "
            [disabled]="
              documentType == 'cotizacion' ||
              btnWebpayPost ||
              alertCartShow ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro)
            "
            *ngIf="
              userSession.userRole != userRoleType.BUYER &&
              paymentMethodActive == 'webPay' &&
              !guest
            "
            (click)="creteateTransactionTransBank()"
            class="btn btn-lg text-sm btn-secondary w-100 text-center"
          >
            Ir a pagar <i class="fas fa-chevron-right"></i>
          </button>
          <!-- End::pagar con webpay (no comprador ni invitado) (mobile) (ir a pagar12) -->

          <!-- Start::pagar con webpay siendo invitado (mobile) (ir a pagar13) -->
          <button
            name="paymentwebpay2"
            *ngIf="guest && paymentMethodActive == 'webPay'"
            [disabled]="
              documentType == 'cotizacion' ||
              !formVisita.valid ||
              !validado ||
              alertCartShow ||
              btnWebpayPost ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro) ||
              (guest &&
                selectedDocument === invoiceType.INVOICE &&
                (!formDireccion.valid || !tienda))
            "
            (click)="creteateTransactionTransBank()"
            class="btn btn-lg text-sm btn-secondary w-100 text-center"
          >
            Ir a pagar <i class="fas fa-chevron-rightp"></i>
          </button>
          <!-- End::pagar con webpay siendo invitado (mobile) (ir a pagar13) -->

          <!-- Start::pagar con mercadopago (no comprador ni invitado) (mobile) (ir a pagar14) -->
          <button
            name="paymentMercadopago"
            [disabled]="
              documentType == 'cotizacion' ||
              btnWebpayPost ||
              alertCartShow ||
              !selectedDocument ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro)
            "
            *ngIf="
              userSession.userRole != userRoleType.BUYER &&
              paymentMethodActive == 'mercadopago' &&
              !guest
            "
            (click)="paymentMercadopago()"
            class="btn btn-lg text-sm btn-secondary w-100 text-center"
          >
            Ir a pagar <i class="fas fa-chevron-right"></i>
          </button>
          <!-- End::pagar con mercadopago (no comprador ni invitado) (mobile) (ir a pagar14) -->

          <!-- Start::pagar con mercadopago siendo invitado (mobile) (ir a pagar15) -->
          <button
            *ngIf="guest && paymentMethodActive == 'mercadopago'"
            name="paymentMercadopago2 "
            [disabled]="
              documentType == 'cotizacion' ||
              !formVisita.valid ||
              !validado ||
              alertCartShow ||
              btnWebpayPost ||
              !selectedDocument ||
              (!userSession.businessLine &&
                selectedDocument === invoiceType.INVOICE &&
                !selectedGiro) ||
              (guest &&
                selectedDocument === invoiceType.INVOICE &&
                (!formDireccion.valid || !tienda))
            "
            (click)="paymentMercadopago()"
            class="btn btn-lg text-sm btn-secondary w-100 tex-tcenter"
          >
            Ir a pagar <i class="fas fa-chevron-right"></i>
          </button>
          <!-- End::pagar con mercadopago siendo invitado (mobile) (ir a pagar15) -->

          <!-- Start::solicitar compra -->
          <button
            name="purchaseRequestAll "
            *ngIf="
              userSession.userRole == userRoleType.BUYER &&
              paymentMethodActive != 'sinDefinir'
            "
            (click)="purchaseRequestAll()"
            [disabled]="formOv.invalid || isVacio(archivo)"
            class="btn btn-lg btn-secondary w-100 text-center"
          >
            Solicitar Compra *
          </button>
          <button
            name="purchaseRequest "
            *ngIf="
              userSession.userRole == userRoleType.BUYER &&
              paymentMethodActive == 'sinDefinir'
            "
            (click)="purchaseRequest()"
            class="btn btn-lg btn-secondary w-100 text-center"
          >
            Solicitar Compra *
          </button>
          <!-- End::solicitar compra -->
        </div>
        <div
          class="mt-1 col-12 py-0 px-1"
          *ngIf="userSession.userRole == userRoleType.BUYER"
        >
          <em
            >* Se generará una solicitud de compra y debe ser aprobada por tu
            supervisor antes de generar el pedido.
          </em>
        </div>
        <div class="mt-1 col-12 py-0 px-1">
          <a
            [href]="config.fullUrl"
            style="color: #118565; text-align: center; font-weight: bold"
          >
            Seguir comprando</a
          >
        </div>
      </div>
      } @else{
      <div class="row">
        <div class="mt-3 col-12 ps-3 ps-3">
          <button
            name="paymentNiubiz"
            [disabled]="!isActive.value"
            *ngIf="guest && paymentMethodActive == 'Niubiz'"
            (click)="creteateTransactionNiubiz()"
            class="btn btn-lg btn-secondary px-0 w-100 text-center"
          >
            Ir a pagar
            <i class="fas fa-chevron-right" style="margin-left: 10px"></i>
          </button>

          <button
            name="paymentNiubiz"
            [disabled]="!isActive.value"
            *ngIf="
              userSession.userRole != userRoleType.BUYER &&
              paymentMethodActive == 'Niubiz' &&
              !guest
            "
            (click)="creteateTransactionNiubiz()"
            class="btn btn-lg btn-secondary px-0 w-100 text-center"
          >
            Ir a pagar
            <i class="fas fa-chevron-right" style="margin-left: 10px"></i>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</ng-container>
<!-- End::resumen de tu compra (mobile) (no existe en desktop)-->

<button
  #openModalButton
  id="openModalButton"
  [hidden]="true"
  data-bs-toggle="modal"
  data-bs-target="#stockAlertModal"
>
  modal
</button>

<!-- Start::modal para informar a cliente que hubieron problemas de stock -->
<div
  class="modal fade"
  id="stockAlertModal"
  tabindex="-1"
  data-bs-backdrop="static"
  aria-labelledby="saveCartModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6>
          No se ha encontrado stock suficiente para los siguientes productos:
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body" style="min-height: auto">
        <div
          *ngFor="let productoSinStock of productosSinStock"
          class="row flex justify-content-center align-items-center"
        >
          <div class="col-2 py-0">
            <img
              *ngIf="productoSinStock.images"
              [src]="
                productoSinStock.images['250']
                  ? productoSinStock.images['250'][0]
                  : productoSinStock.images['150']
                  ? productoSinStock.images['150'][0]
                  : './assets/images/products/no-image-ficha.jpg'
              "
              onError="this.src='./assets/images/products/no-image-ficha.jpg'"
              style="height: 60px; width: 60px"
            />

            <img
              *ngIf="!productoSinStock.images"
              [src]="
                productoSinStock.images['250']
                  ? productoSinStock.images['250'][0]
                  : productoSinStock.images['150']
                  ? productoSinStock.images['150'][0]
                  : './assets/images/products/no-image-ficha.jpg'
              "
              onError="this.src='./assets/images/products/no-image-ficha.jpg'"
              style="height: 60px; width: 60px"
            />
          </div>
          <div class="col-7 py-0 text-truncate">
            {{ productoSinStock.name | titlecase }}
          </div>
          <div class="col-3 py-0">Cant: {{ productoSinStock.quantity }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-warning"
          (click)="VolverPaginaCarro()"
          data-bs-dismiss="modal"
        >
          Volver a Carro
        </button>
      </div>
    </div>
  </div>
</div>
<!-- End::modal para informar a cliente que hubieron problemas de stock -->

<ng-template #bankmodal let-c="close" let-d="dismiss">
  <app-bancoslist />
</ng-template>
